import { useCallback } from 'react';
import Modal from 'utils/packages/Modal';
import { TimestampStorage, TimestampStorageKeys } from 'utils/TimestampStorage';
import { useNotificationsPermissions } from './useNotificationsPermissions';
import { NotificationsPermissionState, } from './useNotificationPermissionTypes';
const strings = {
    notifyModalNotNow: 'Not right now',
    notifyModalEnable: 'Notify me',
};
const SEVEN_DAYS_MS = 7 * 24 * 60 * 60 * 1000;
/**
 * @returns A function that shows a modal if notification isn't turned on, and modal wasn't shown recently.
 */
export function useSuggestNotification(source) {
    const { activatePush, permissionState } = useNotificationsPermissions(source);
    return useCallback(async (title, subtitle) => {
        if (permissionState !== NotificationsPermissionState.Enabled &&
            permissionState !== NotificationsPermissionState.Unavailable) {
            const shouldShow = await TimestampStorage.notSince(TimestampStorageKeys.NOTIFICATION_PERMISSION_PROMPT, SEVEN_DAYS_MS);
            if (shouldShow) {
                Modal.showConfirmation({
                    title,
                    subtitle,
                    confirmButtonTitle: strings.notifyModalNotNow,
                    cancelButtonTitle: strings.notifyModalEnable,
                    onPressCancel: () => activatePush('openSettings'),
                });
                await TimestampStorage.stamp(TimestampStorageKeys.NOTIFICATION_PERMISSION_PROMPT);
            }
        }
    }, [permissionState, activatePush]);
}
